import LeadFormDetails from 'components/company_leads/lead_form_v2/LeadFormDetails';
import LeadFormHeader from 'components/company_leads/lead_form_v2/LeadFormHeading';
import {
  onSubmitLeadForm,
  onLeadFormFailure,
  onLeadFormSuccess,
} from 'components/company_leads/lead_form_v2/lead_form_helpers';
import type { FormikHelpers } from 'formik';
import type {
  LeadFormDetailsValues,
  OnLeadFormSuccessProps,
} from 'components/company_leads/lead_form_v2/types';
import { Box } from '@gusto/workbench';
import type { EmbeddedLeadFormExploreValues } from 'packages/signup/components/explore/embeddedLeadForm/types';
import useIsFilledLeadForm from 'packages/signup/components/explore/embeddedLeadForm/useIsFilledLeadForm';
import { phoneNumberNoFormatting } from 'packages/signup/helpers/validateSurvey';
import { SubmittedFromValue } from 'packages/signup/components/explore/embeddedLeadForm/types';
import { trackLeadFormSubmissionForPixel } from 'components/company_leads/lead_form_v2/track';

const trackEmbeddedLeadFormSubmission = ({
  submittedFrom,
  response,
  values,
}: OnLeadFormSuccessProps) => {
  // If new lead is created send this event on submit after validation - Learning Journey Lead Form
  trackLeadFormSubmissionForPixel();
  onLeadFormSuccess({ submittedFrom, response, values });
};

export async function onSubmitEmbeddedLeadForm(
  values: EmbeddedLeadFormExploreValues,
  formikOpts: FormikHelpers<LeadFormDetailsValues>,
  leadOriginSubtype: string,
  isFilledLeadForm: boolean
) {
  const leadFormValues = {
    companyName: values?.companyName || '',
    email: values?.email || '',
    firstName: values?.firstName || '',
    lastName: values?.lastName || '',
    industry: values?.industry || 'Other',
    numberEmployees: values?.numberEmployees || 0,
    phone: (values?.phone ? phoneNumberNoFormatting(values.phone) : '') || '',
  };

  if (!isFilledLeadForm) {
    trackEmbeddedLeadFormSubmission({
      submittedFrom: SubmittedFromValue.LEARNING_JOURNEY_FORM,
      response: leadFormValues,
      values: leadFormValues,
    });

    await onSubmitLeadForm({
      values: leadFormValues,
      formikOpts,
      onFailure: onLeadFormFailure,
      onSuccess: trackEmbeddedLeadFormSubmission,
      submittedFrom: SubmittedFromValue.LEARNING_JOURNEY_FORM,
      leadOrigin: 'GCorp',
      leadOriginSubtype,
    });
  }
}

export default function EmbeddedLeadForm({
  primaryCTACopy = "Let's go →",
  primaryCTAOnClick,
}: {
  primaryCTACopy?: string;
  primaryCTAOnClick?: () => void;
}) {
  const isFilledLeadForm = useIsFilledLeadForm();
  return (
    <Box marginTop={isFilledLeadForm ? 8 : 14} marginBottom={5}>
      {!isFilledLeadForm && (
        <>
          <LeadFormHeader
            heading="Tell us a little about you."
            subheading="We’ll use this information to provide guided recommendations and relevant links."
            textAlign="left"
          />
        </>
      )}
      <LeadFormDetails
        primaryCTACopy={primaryCTACopy}
        isFilledOutLeadForm={isFilledLeadForm}
        primaryCTAOnClick={primaryCTAOnClick}
      />
    </Box>
  );
}
